<template>
  <v-main class="loginscreen-background">
    <v-container fluid id="login" fill-height tag="section" style="margin: 0">
      <v-row justify="end" align="center">
        <v-col offset-md="7" offset-sm="6">
          <form name="loginform" @submit.prevent="contin(screenFlag)">
            <v-card
              elevation="10"
              v-if="screenFlag === 'Login'"
              color="White"
              light
              max-width="100%"
              width="400"
              class="pa-3"
              rounded="lg"
            >
              <template>
                <v-img
                  class="mx-auto mt-4 mb-7"
                  max-width="160"
                  alt="Intellitots Admin"
                  :src="tots_image"
                >
                </v-img>
                <v-card-text class="text-center">
                  <v-text-field
                    color="grey darken-3"
                    label="Enter Username"
                    placeholder=" "
                    prepend-icon="mdi-account"
                    name="email"
                    v-model="email"
                    required
                    autofocus
                  />
                </v-card-text>
                <v-card-actions class="justify-end mr-2 mb-2">
                  <v-btn
                    elevation="1"
                    color="error"
                    class="font-weight-bold"
                    type="submit"
                    dark
                    :loading="loading"
                  >
                    Continue
                    <v-icon right class="mr-0">mdi-arrow-right</v-icon>
                  </v-btn>
                </v-card-actions>
              </template>
            </v-card>
          </form>
          <template v-if="screenFlag === 'LoginStepOne'">
            <v-card
              elevation="10"
              color="white"
              light
              max-width="100%"
              width="400"
              class="pa-3"
              rounded="lg"
            >
              <form name="loginformSubmit" @submit.prevent="login(screenFlag)">
                <v-img
                  class="mx-auto mt-4 mb-7"
                  max-width="160"
                  alt="Intellitots Admin"
                  :src="tots_image"
                >
                </v-img>
                <v-card-text class="text-center">
                  <v-text-field
                    placeholder=" "
                    color=" grey darken-3"
                    label="Password"
                    prepend-icon="mdi-lock-outline"
                    :type="showPassword ? 'text' : 'password'"
                    autofocus
                    v-model="password"
                    class="subtitle"
                    required
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPassword = !showPassword"
                  />
                  <div class="mr-16 mb-6">
                    <span class="mr-3">
                      <v-icon left>mdi-email-edit</v-icon>{{ email }}
                    </span>
                    <a class="text-decoration-underline" @click="routeToLogin"
                      >Change</a
                    >
                  </div>
                </v-card-text>
                <v-card-actions class="justify-end mr-2 mb-2">
                  <v-btn @click="loginWithOTP" elevation="1" :disabled="loading"
                    >OTP login</v-btn
                  >
                  <v-btn
                    elevation="1"
                    color="error"
                    class="font-weight-bold"
                    type="submit"
                    dark
                    :loading="loading"
                  >
                    Login</v-btn
                  >
                </v-card-actions>
              </form>
            </v-card>
          </template>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>
<script>
import CONSTANTS from '@/utils/constants'
// import Utils from '@/utils'
import stores from '@/stores'

// import http from 'axios'
import _ from 'lodash'

export default {
  name: 'Login',
  data () {
    return {
      tots_image: `${CONSTANTS.RAZORPAY.TOTS_IMAGE}`,
      password: '',
      email: '',
      company: {},
      data: [],
      referenceID: '',
      screenFlag: this.$route.name,
      otpViewFlag: false,
      isPassword: '',
      error: false,
      showPassword: false,
      loading: false,
      isBusAttendent: null
    }
  },
  mounted () {},
  watch: {
    $route (to, from) {
      if (from.name === 'LoginStepOne') {
        this.routeToLogin()
        this.screenFlag = 'Login'
      }
    }
  },

  created: async function () {
    if (this.screenFlag === 'LoginStepOne') {
      this.routeToLogin()
      this.screenFlag = 'Login'
    }
    this.screenFlag = 'Login'
    await stores.studentOrderKits.clearAll()
    await stores.wowKitOrders.clearAll()
    await stores.user.clear()
  },
  logout () {
    this.logout()
  },
  methods: {
    loginWithOTP: async function () {
      this.$router.push({
        name: 'otp',
        params: { referenceID: this.referenceID }
      })
    },
    routeToLogin: function () {
      this.$router.push('/login').catch(() => {})
      this.screenFlag = 'Login'
    },
    logout: async function () {
      await stores.user.clear()
    },
    contin: async function (type) {
      try {
        if (type === 'Login') {
          let params1 = {
            input: this.email.trim()
          }
          this.loading = true
          const response = await http.get(
            `${CONSTANTS.API_URL}/api/admin/check/user`,

            {
              params: params1
            }
          )
          this.data = response.data
          this.referenceID = this.data.referenceID
          this.isPassword = this.data.isPassword
          this.isBusAttendent = this.data.isLoggedIn
        }

        if (this.isPassword === false) {
          this.loginWithOTP()
        } else {
          await this.$router
            .push('/signIn')

            .catch((e) => {
              console.log('Error while Login--', e)
              return this.$dialog.error({
                text: 'Please wait and retry',
                title: 'Error'
              })
            })
          this.screenFlag = 'LoginStepOne'
        }
      } catch (e) {
        return this.$dialog.error({
          text: (e && e.response && e.response.data.message) || e.message,
          title: 'Error'
        })
      } finally {
        this.loading = false
      }
    },
    login: async function (type) {
      try {
        this.$store.commit('setHasEnquiryAccess', '')
        if (this.password.length < 8) {
          return this.$dialog.error({
            text: 'Password should be minimum 8 character',
            title: 'Error'
          })
        }
        this.loading = true
        // this.loadingComponent = this.$buefy.loading.open()
        const response = await http.post(
          `${CONSTANTS.API_URL}/api/auth/local/admin`,
          {
            email: this.email.trim(),
            password: this.password
          }
        )
        const data = response.data
        await stores.user.setToken(data.token)
        await stores.user.setSuperAdmin(data.superAdmin)
        await stores.user.setAccess(data.access)
        await stores.user.refreshInfo()
        await stores.user.init()
        await stores.user.setMenu()
        if (stores.user.ACL.superAdmin) {
          await this.$router.push({ name: 'Dashboard' })
        } else {
          let defaultRoute = _.find(
            stores.user.menu,
            (item) => item.dashboardRoleMap.isDefault
          )
          if (!_.isEmpty(defaultRoute)) {
            try {
              await this.$router
                .push({ name: defaultRoute.name })
                .catch(() => {})
            } catch (e) {
              console.log('The error is =->', e)
              await this.$router.push({ name: 'Profile' }).catch(() => {})
            }
          } else {
            await this.$router.push({ name: 'Profile' }).catch(() => {})
          }
        }
      } catch (e) {
        this.$dialog.error({
          text: (e && e.response && e.response.data.message) || e.message,
          title: 'Error'
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.loginscreen-background {
  background-image: url(http://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/background_Img.jpg);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
</style>
